<app-modal-actionable (openModalEvent)="initData()" (openModalAutomatic)="openAutomatic($event)" [iconSrc]="icon"
    title="{{'administration.sectionsManagement.' + section + '.' + type}}" color="purple" [data]="data"
    [dataIconSrc]="icon" [hideDialog]="hideDialog" class="modal-actionable"
    [sec]="this.section" [type]="this.type">
    <img [src]="icon" alt="action icon" class="action-icon" id="action-icon">
    <span title class="action-title" id="action-title">{{'administration.sectionsManagement.' + section + '.' + type |
        translate}}</span>
    <div content *checkPermission="{ role: 'editor'}">
        <div ngbTooltip="{{('buttons.new' | translate) + ' ' + ('administration.sectionsManagement.' + section + '.' + type | translate)}}"
            placement="left" container="body" tooltipClass="apc-tooltip-left" class="add-float-icon" triggers="hover"
            (click)="addNewForm()">
            <div class="icon" aria-label="plus" [inlineSVG]="'assets/ico/plus-regular.svg'"></div>
        </div>
    </div>
    <div collapsable class="modal-footer p-0">
        <div class="container-fluid m-0 p-0">
            <div *ngIf="data" class="position-relative">
                <div id="modal-blanket" class="d-none"></div>
                <ng-template ngFor let-item [ngForOf]="forms.controls" let-i="index">
                    <app-collapsable-row [imgSrc]="icon" [title]="generateRowTitle(item) || noValueTitle" isModal="true"
                        [isCollapsed]='item.isCollapsed' [index]="i" [section]="section" [type]="type"
                        (collapseEvent)="toggleElement(item.value.identifier)" [isEdit]="item.editForm">
                        <apc-action-card [headerCursorPointer]="true">
                            <img icon [src]="icon" alt="user" />
                            <span title>{{ generateRowTitle(item)}}</span>

                            <apc-admin-crud-action-buttons (editEvent)="editFormEvent(item, $event)"
                                [edit]="item.editForm" (saveEvent)="saveForm(item)" (cancelEvent)="cancelForm(item)"
                                (preDeleteEvent)="hideDialog =  $event" (deleteEvent)="deleteItem(item)"
                                [section]="section" [form]="item" buttons>
                            </apc-admin-crud-action-buttons>
                            <div content class="fullwidth mb-3" [class.editForm]="item.editForm">
                                <form [formGroup]="item">
                                    <div class="container-fluid">
                                        <apc-code-value-form
                                            *ngIf="section === 'order' && type !== 'type' && type !== 'product' && type !== 'department'"
                                            [form]="item" [section]="section" [type]="type">
                                        </apc-code-value-form>
                                        <nejo-order-type-form *ngIf="section === 'budget' && type === 'type'"
                                            [form]="item" [section]="section" [type]="type"></nejo-order-type-form>
                                        <apc-product-form *ngIf="section === 'order' && type === 'product'"
                                            [form]="item" [section]="section"></apc-product-form>
                                        <apc-admin-department-form *ngIf="section === 'budget' && type === 'department'"
                                            [form]="item" [section]="section"></apc-admin-department-form>
                                    </div>
                                </form>
                            </div>
                        </apc-action-card>
                    </app-collapsable-row>
                </ng-template>
            </div>
        </div>
    </div>
</app-modal-actionable>